import React from 'react';

import Head from 'next/head';

import { Articles } from 'modules/casesdesucesso/Articles';
import { CasesdeSucessoContentCollection } from 'modules/casesdesucesso/Articles/Articles.types';
import { Hero } from 'modules/casesdesucesso/Hero';
import { HeroCasesCollection } from 'modules/casesdesucesso/Hero/Hero.types';
import { Footer } from 'modules/common/Footer';
import { FooterCollection } from 'modules/common/Footer/Footer.types';
import { Header } from 'modules/common/Header';
import { HeaderCollection } from 'modules/common/Header/Header.types';

import contentfulData from '../../services/contentful';
import { queryCases } from '../../services/contentful/querys';

type IntegrationsProps = {
  menuPrincipal: HeaderCollection;
  menuRodape: FooterCollection;
  heroCases: HeroCasesCollection;
  casesdesucesso: CasesdeSucessoContentCollection;
};

const Casesdesucesso = ({
  casesdesucesso,
  heroCases,
  menuPrincipal,
  menuRodape,
}: IntegrationsProps) => {
  return (
    <div>
      <Head>
        <title>Olist Vnda - Tecnologia em E-commerce</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header menus={menuPrincipal.menus} />
      <main>
        <Hero description={heroCases.description} items={heroCases.items} title={heroCases.title} />
        <Articles items={casesdesucesso.items} />
      </main>

      <Footer menus={menuRodape.menus} />
    </div>
  );
};

export default Casesdesucesso;

export async function getServerSideProps() {
  const data = await contentfulData(queryCases());

  return {
    props: data,
  };
}
